import { useContext, useMemo } from 'react';

import { AnimatedTransition } from '../../../../../components/animated-transition';
import { BackgroundMessage } from '../../../../../components/background-message';
import { PORTFOLIO_MESSAGES } from '../../../../../constants/reports/reports-messages';
import { StrikeReportContext } from '../../../../../providers/strike-report';
import { useAggregatedStrikeReportEffect } from '../hooks/use-aggregated-strike-report';
import { usePerAccountStrikeReportEffect } from '../hooks/use-per-account-strike-report';

import { StrikeReportHeader } from './strike-report-header';
import { StrikeReportTable } from './strike-report-table';

import './styles.scss';

export const StrikeReportBody = () => {
  const { isStrikeReportLoading, strikeReportData } = useContext(StrikeReportContext);

  usePerAccountStrikeReportEffect();
  useAggregatedStrikeReportEffect();

  const renderStrikeReportBody = useMemo(() => {
    if (isStrikeReportLoading) {
      return (
        <div className="strike-report-body">
          <BackgroundMessage isLoading />
        </div>
      );
    }

    if (strikeReportData?.isError) {
      return (
        <div className="strike-report-body">
          <BackgroundMessage
            message={PORTFOLIO_MESSAGES.ERROR_REQUEST_STRIKE_REPORT}
            type="error"
          />
        </div>
      );
    }

    if (!strikeReportData?.data) {
      return (
        <div className="strike-report-body">
          <BackgroundMessage message={PORTFOLIO_MESSAGES.NO_DATA_FOUND} />
        </div>
      );
    }

    return (
      <AnimatedTransition timeout={800} className="strike-report-body">
        <StrikeReportHeader />
        <StrikeReportTable reportData={strikeReportData} />
      </AnimatedTransition>
    );
  }, [isStrikeReportLoading, strikeReportData]);

  return renderStrikeReportBody;
};
